export const transformStringSymbols = (str, map) => {
    let result = '';
    for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);
        result += map[char] || char;
    }
    return result;
};
